import { Controller } from "@hotwired/stimulus"

// Drives the campaign Send modal: switches the form's action URL and submit
// button label based on the selected radio (schedule send / mark complete /
// send preview).
//
// The dialog used to host two batch flavors (Send batch, Send all remaining)
// with a numeric batch_size input. The campaign send model is now
// materialize-on-start (CampaignScheduler enqueues per-account delayed jobs),
// so there's nothing to size and the batch fields were removed.
export default class extends Controller {
  static targets = ["form", "submitButton", "kindRadio"]

  connect() {
    this.update()
  }

  update() {
    const selected = this.kindRadioTargets.find(r => r.checked)
    if (!selected) return

    this.formTarget.action = selected.dataset.actionUrl
    this.submitButtonTarget.textContent = selected.dataset.submitLabel
  }
}
